import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=82dc8054&scoped=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=ts"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts"
import style0 from "./ErrorDialog.vue?vue&type=style&index=0&id=82dc8054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dc8054",
  null
  
)

export default component.exports